import React from 'react';
import { Table } from 'react-bootstrap';
import './App.css';


const DataTable = (props) => {
  let ResArray = props.Resval.res;
  let BoolIac0 = props.Resval.BoolIac0;
  let Imax = props.Resval.Imax;
  let T50 = props.Resval.T50;
  let Iac = props.Resval.Iac;

  return (
    <div className='fullTable'>
      {ResArray &&
        <div>
          <div className="datatable-title1 col s12">
            <div className="col l3 m0 s0"></div>
            <div className="datatable-title col l6 m12 s12">
              {/* <Modal.Header> */}
              <div className="col l4">Imax: {Imax} A </div>
              <div className="col l4">T50: {T50} us </div>
              <div className="col l4">Iac: {Iac} A </div>
              {/* </Modal.Header> */}

            </div>
            <div className="col l3 m0 s0"></div>
          </div>
          <Table responsive className="datatable-data col l12 s12">
            <thead>
              <tr>
                <th>Under 230VAC</th>
                <th>B10</th>
                <th>B13</th>
                <th>B16</th>
                <th>B20</th>
                <th>C10</th>
                <th>C13</th>
                <th>C16</th>
                <th>C20</th>
                <th>D16</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Max No.</td>
                {Array.from({ length: 9 }).map((_, index) => (
                  <td key={'Col' + index}>{ResArray[index]}</td>
                ))}
              </tr>

            </tbody>
            </Table>

            <tr>
              <td>Note: These calculated values are based on MCB S200 series manufactured by ABB except for HVG/HVGC series, which are calculated by using MCB S260 series of the same manufacturer. 
                
              </td>

            </tr>


          {BoolIac0 &&
            <tr className='warningrow'>
              <td className="col l12 s12">
                INVALID input current value, results may not correct!!!
        </td>
            </tr>
          }
        </div>
      }
      {!ResArray &&
        <div className='fill-window'>
          <h1 className='intro-logo'>
            <img src={'MW.jpg'} className='logo' alt='logo' />
          </h1>
          <h1 className='intro'>Powered by MEAN WELL</h1>
          <h1 className='intro-title'>Circuit breaker selector</h1>
        </div>
      }
    </div>
  );
}
export default DataTable;
